export default __webpack_public_path__ + "assets/models/fbfc8fd9828ce5c6edd3aeeece98c48e.glb";